export const data = {
  placeTypes: [
    {
      name: 'Parking IN/OUT',
      key: 'parking_in_out'
    },
    {
      name: 'Parking Layout',
      key: 'parking_layout'
    },
    {
      name: 'General',
      key: 'general'
    }
  ],
  eventField: [
    {
      name: 'Cam ID',
      keyLabel: 'camId'
    },
    {
      name: 'Event time',
      keyLabel: 'event_time'
    },
    {
      name: 'Name',
      keyLabel: 'name'
    },
    {
      name: 'Priority',
      keyLabel: 'priority'
    },
    {
      name: 'Reported priority',
      keyLabel: 'priorityReported'
    },
    {
      name: 'Type',
      keyLabel: 'type'
    },
    {
      name: 'Event image',
      keyLabel: 'image'
    },
  ],
  eventPriorities: [
    {
      name: 'Very low',
      keyLabel: 0,
    },
    {
      name: 'Low',
      keyLabel: 1,
    },
    {
      name: 'Medium',
      keyLabel: 2,
    },
    {
      name: 'High',
      keyLabel: 3,
    },
  ],
  eventImages: [
    {
      name: 'Primary Image',
      keyLabel: 'primaryImage'
    },
    {
      name: 'Secondary Image',
      keyLabel: 'secondaryImage'
    },
  ],
  priority: [
    'Very low','Low','Medium','High'
  ],
  priorityValues: [
    {
      label: 'Very low',
      value: 0
    },{
      label: 'Low',
      value: 1
    },
    {
      label: 'Medium',
      value: 2,
    },
    {
      label: 'High',
      value: 3
    }
  ],
  eventData: [
    {
      label: 'Very low and above',
      value: 0
    },
    {
      label: 'Low and above',
      value: 1
    },
    {
      label: 'Medium and above',
      value: 2
    },
    {
      label: 'High and above',
      value: 3
    },
  ]
}


// WEBPACK FOOTER //
// ./src/data/AdminData.js